import styled from 'styled-components';
import { SSIFlexDirectionColumnViewStyled, SSIFlexDirectionRowViewStyled } from '../../containers';
import { SSITextH3Styled, SSITextH5Styled } from '../../../fonts';
export const CredentialViewItemContainerStyled = styled(SSIFlexDirectionRowViewStyled) `
  padding: 18px 24px;
  gap: 8px;
  align-items: center;
`;
export const CredentialViewItemDetailsContainerStyled = styled(SSIFlexDirectionColumnViewStyled) `
  gap: 6px;
  min-width: 245px;
`;
export const CredentialViewItemTitleCaptionStyled = styled(SSITextH3Styled) `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
`;
export const CredentialViewItemStatusContainerStyled = styled.div `
  margin-top: 3px;
  margin-left: auto;
  padding-left: 9px;
`;
export const CredentialViewItemExpirationDateCaptionStyled = styled(SSITextH5Styled) `
  margin-left: auto;
`;
